import WidgetBase from '../widget.base';

import { each , debounce2, capitalizeFirstLetter } from 'App/lib/util';
import body from 'App/services/body';
import { mq, scrollTo } from '../../lib/util';
import BackToTopService from '../../services/back-to-top';
export default class DirectoryWidget extends WidgetBase {
    static selector = '[data-js-directory]';

    activeFilter;
    activeSubfilters = [];
    searchTerm;
    viewType = 'grid';

    constructor(el) {
        super(el);

        this.listings = this.el.querySelector('[data-listings]');
        this.listingRows = this.el.querySelectorAll('[data-listing-row]')
        this.headers = this.el.querySelectorAll('[data-header]');
        this.searchInputs = this.el.querySelectorAll('[data-search]');
        this.searchClear = this.el.querySelectorAll('[data-clear-search]');
        this.filters = this.el.querySelectorAll('[data-filter]');
        this.filterAll = this.el.querySelector('[data-filter="all"]');
        this.subfilters = this.el.querySelectorAll('[data-subfilter]');
        this.viewToggles = this.el.querySelectorAll('[data-view-toggle]');
        this.selectedFiltersList = this.el.querySelector('[data-selected-filters]');
        this.selectedFiltersContainer = this.el.querySelector('[data-selected-filters-container]');
        this.listingHeaders = this.el.querySelectorAll('[data-listing-header]');
        this.mobileFilterBtn = this.el.querySelectorAll('[data-mobile-filter-btn]');
        this.directoryContainer = this.el.querySelector('[data-directory-container]');
        this.directoryHeaderMobile = this.el.querySelector('.directory-header__mobile');
        this.sideBar = this.el.querySelector('.directory__sidebar');
        this.activeOrderHeader;

        each(this.mobileFilterBtn, (btn) => {
            btn.addEventListener('click', () => {
                // if (btn.classList.contains('open') && !btn.classList.contains('sub')) {
                //     btn.innerHTML = 'Filter';
                // } else {
                //     btn.innerHTML = 'Apply';
                // }
                btn.classList.toggle('open');
                document.body.classList.toggle('lock');
                this.directoryContainer.classList.toggle('open');
            });
        })

        const debouncedSearchHandler = debounce2(this.searchHandler.bind(this), 200);
        const initialState = this.getInitialState();
        const hasInitialFilter = initialState.hasOwnProperty('filter') && initialState.filter.length > 0;

        each(this.searchClear, (trigger) => {
            trigger.addEventListener('click', this.clearSearch.bind(this));
        })

        each(this.searchInputs, (input) => {

            if (initialState.hasOwnProperty('term')) {
                input.value = initialState.term;
            }

            input.addEventListener('keydown', (e) => {
                setTimeout(() => {
                    debouncedSearchHandler(e, input.value);
                })
            });
        })

        each(this.filters, (filter) => {
            filter.addEventListener('click', (e) => {
                this.filterHandler(e, filter);
            });

            if (hasInitialFilter && initialState.filter === filter.dataset.filter) {
                filter.classList.add('active');
                this.activeFilter = filter;
                this.createFilterClearTrigger(filter);
            }
        });

        each(this.subfilters, (filter) => {
            filter.addEventListener('click', (e) => {
                e.stopPropagation();
                this.toggleSubfilter(filter);
            });

            if (initialState.hasOwnProperty('subfilter')) {
                each(initialState.subfilter, (subfilter) => {
                    if (subfilter === filter.dataset.subfilter) {
                        if (hasInitialFilter == false || (hasInitialFilter && filter.classList.contains(initialState.filter))) {
                            filter.classList.add('active');
                            this.createSubfilterClearTrigger(filter);
                        }
                    }
                });
            }
        });

        each(this.viewToggles, (toggle) => {
            toggle.addEventListener('click', (e) => {
                this.changeView(toggle.dataset.viewToggle);
            })
        });

        each(this.selectedFiltersList.querySelectorAll('[data-selected-filter]'), (filter) => {
            filter.addEventListener('click', (e) => {
                this.toggleSubfilter(filter);
            })
        });

        each(this.listingHeaders, (header) => {
            header.addEventListener('click', (e) => {
                this.orderColumn(header);
            });
        });

        if(initialState.term) {
            this.searchHandler(null, initialState.term);
        }

        if(initialState.filterOnInit) {
            if (initialState.filter === 'dining') {
                this.disableSubfilters();
                this.diningFilter(true);
            } else {
                this.filter();
            }
        }


        setTimeout(() => {
            if (!mq(1345)) {
                const height = this.directoryHeaderMobile.offsetHeight * -1;
                this.sideBar.style.top = `${height}px`;
            }
            this.loaded();
        },500)

        BackToTopService.init(el, true);
    }

    changeView(type) {
        if(type === this.viewType) {
            return;
        }

        this.listings.classList.remove(`directory__listings--` + this.viewType);
        this.listings.classList.add(`directory__listings--` + type);

        // update classes
        each(this.viewToggles, (toggle) => {
            if(toggle.dataset.viewToggle === type) {
                toggle.classList.add('active');
            }else{
                toggle.classList.remove('active');
            }
        });

        this.viewType = type;
    }

    filter() {
        if(this.activeFilter.dataset.filter === 'all') {
            this.clearSearch();
        }

        each(this.listings.children, (listing) => {
            let found = this.activeFilter.dataset.filter === 'all';
            if (this.activeSubfilters.length) {
                each(this.activeSubfilters, (activeFilter) => {
                    if (listing.classList.contains(activeFilter.filter.dataset.subfilter) && listing.classList.contains('shopping')) {
                        found = true;
                    }
                });
            } else {
                if (listing.classList.contains(this.activeFilter.dataset.filter)) {
                    found = true;
                }
            }

            if (found) {
                listing.classList.remove('hidden-by-filter');
            } else {
                listing.classList.add('hidden-by-filter');
            }
        });

        this.checkForZeroResults();
        this.recordState();
    }

    diningFilter(isOnload = false) {
        if(this.activeFilter.dataset.filter === 'all') {
            this.clearSearch();
        }
        const diningSubfilters = [];
        each(this.listings.children, (listing) => {
            let found = this.activeFilter.dataset.filter === 'all';
            if (this.activeSubfilters.length) {
                found = true;
                each(this.activeSubfilters, (activeFilter) => {
                    if (!listing.classList.contains(activeFilter.filter.dataset.subfilter) || !listing.classList.contains('dining')) {
                        found = false;
                    }
                });
            } else {
                if (listing.classList.contains(this.activeFilter.dataset.filter)) {
                    found = true;
                }
            }

            if (found) {
                listing.classList.remove('hidden-by-filter');
                const tempListing = listing.dataset.listingRow.split(' ');
                tempListing.forEach((value) => {
                    if (!diningSubfilters.includes(value)) {
                        diningSubfilters.push(value);
                    }
                });
            } else {
                listing.classList.add('hidden-by-filter');
            }
        });
        this.enableSubfilters(diningSubfilters)
        this.checkForZeroResults();
        if (isOnload === false) {
            this.recordState();
        }
    }

    filterHandler(e, filter) {
        if (this.activeFilter.dataset.filter !== filter.dataset.filter) {
            this.clearActiveSubfilters();
            this.setActiveFilter(filter);
            setTimeout(() => {
                scrollTo(document.scrollingElement, 0, 500);
            }, 500);
        }
        const filterBy = filter.dataset.filter;

        if (filter.classList.contains('active')) {
            const dropdown = filter.nextElementSibling;

            // open / close dropdown
            if (dropdown && typeof dropdown.dataset.dropdown !== 'undefined') {
                if (filter.parentElement.classList.contains('open')) {
                    this.closeDropdown(filter);
                } else {
                    this.openDropdown(filter);
                }
            }

        } else {
            this.clearActiveSubfilters();
            this.setActiveFilter(filter);
        }

        if (this.activeFilter && filterBy === this.activeFilter.dataset.filter && this.activeSubfilters.length > 0) {
            return;
        } else {
            if (filter.dataset.filter === 'dining') {
                this.diningFilter();
            } else {
                this.filter();
            }
        }
    }

    clearActiveSubfilters() {
        if (this.activeFilter) {
            this.closeDropdown(this.activeFilter);
        }
        this.selectedFiltersContainer.classList.remove('open')
        this.selectedFiltersList.innerHTML = "";

        each(this.activeSubfilters, (item) => {
            item.filter.classList.remove('active');
        })
        this.activeSubfilters = [];
    }

    closeDropdown(filter) {
        if (filter.nextElementSibling !== null) {
            filter.nextElementSibling.style.height = '';
        }
        filter.parentElement.classList.remove('open');

        if(!mq('md')) {
            body.unlock();
        }

        document.removeEventListener('click', this.closeDropdown);
    }

    openDropdown(filter) {
        const dropdown = filter.nextElementSibling;
        if (dropdown !== null) {
            dropdown.style.height = 'auto';
            let height = dropdown.clientHeight + 'px';
            dropdown.style.height = 0;
            setTimeout(() => {
                dropdown.style.height = height;
            }, 0);
        }

        setTimeout(() => {
            filter.parentElement.classList.add('open');
        })

        document.addEventListener('click', this.closeDropdown.bind(this, filter));
    }

    disableSubfilters() {
        each(this.subfilters, (filter) => {
            if (!filter.classList.contains('active') && filter.classList.contains('dining')) {
                filter.setAttribute('disabled','disabled');
            }
        });
    }

    enableSubfilters(subfiltersToEnable = []) {
        each(this.subfilters, (filter) => {
            if (subfiltersToEnable.includes(filter.dataset.subfilter)) {
                filter.removeAttribute('disabled');
            }
        });
    }

    toggleSubfilter (filter) {
        if (filter.classList.contains('active')) {
            // remove subfilter
            filter.classList.remove('active');

            let index = this.activeSubfilters.length;
            while(index--) {
                if (this.activeSubfilters[index].filter.dataset.subfilter === filter.dataset.subfilter) {
                    this.activeSubfilters[index].clearTrigger.remove();
                    this.activeSubfilters.splice(index, 1);
                }
            }

            if(!this.activeSubfilters.length > 0) {
                this.selectedFiltersContainer.classList.remove('open');
            }
            this.enableSubfilters();
        } else {
            // add subfilter
            this.createSubfilterClearTrigger(filter);
            filter.classList.add('active');
            this.disableSubfilters();
        }

        if (filter.classList.contains('dining')) {
            this.diningFilter();
        } else {
            this.filter();
        }
    }

    createSubfilterClearTrigger(filter) {
        let span = document.createElement('span');
        span.innerText = filter.innerText;
        span.addEventListener('click', (e) => {
            this.toggleSubfilter(filter);
        });

        this.selectedFiltersList.append(span);
        this.activeSubfilters.push({
            clearTrigger: span,
            filter: filter,
        });

        // open the filter bar if it's not already open
        if(!this.selectedFiltersContainer.classList.contains('open')) {
            this.selectedFiltersContainer.classList.add('open');
        }
    }

    createFilterClearTrigger(filter) {
        if(filter.dataset.filter === 'all') {
            return;
        }

        let span = document.createElement('span');
        span.innerText = capitalizeFirstLetter(filter.innerText);

        span.addEventListener('click', (e) => {
            this.clearAllFilters();
        });

        this.selectedFiltersList.append(span);

        // open the filter bar if it's not already open
        if(!this.selectedFiltersContainer.classList.contains('open')) {
            this.selectedFiltersContainer.classList.add('open');
        }
    }

    updateHeaders(headerText) {
        each(this.headers, (header) => {
            header.innerText = headerText;
        })
    }

    setActiveFilter (filter) {
        if(this.activeFilter) {
            this.activeFilter.classList.remove('active');
        }

        filter.classList.add('active');
        this.activeFilter = filter;
        this.updateHeaders('Directory | ' + capitalizeFirstLetter(filter.dataset.filter));

        this.createFilterClearTrigger(filter);
    }

    clearAllFilters() {
        this.activeFilter.classList.remove('active');
        this.activeFilter = this.filterAll;
        this.activeFilter.classList.add('active');
        this.activeSubfilters = [];
        this.filter();
        this.updateHeaders('Directory');
        this.selectedFiltersContainer.classList.remove('open');
        // Clear all subfilters
        each(this.subfilters, (filter) => {
            filter.classList.remove('active');
        });
    }

    recordState() {
        let subfilterArr = [];
        if(this.activeSubfilters) {
            each(this.activeSubfilters, (subfilter) => {
                subfilterArr.push(subfilter.filter.dataset.subfilter);
            });
        }

        const state = {
            filter: this.activeFilter ? this.activeFilter.dataset.filter : null,
            subfilter: subfilterArr,
            term: this.searchTerm,
        };

        let url = window.location.pathname + "?";

        let arr = Object.keys(state);

        url += arr
            .filter((prop) => state[prop] && state[prop].length)
            .map((prop) => {
                const value = typeof state[prop] === 'string' ? state[prop] : state[prop].join('|');
                return `${prop}=${value}`;

            })
            .join('&');

        window.history.pushState(state, null, url);
    }

    clearSearch() {
        each(this.searchInputs, (input) => {
            input.value = '';
        })

        this.searchHandler(null, null);
    }

    activateSearch() {
        each(this.searchInputs, (input) => {
            input.closest('.directory__search').classList.add('active');
        })
    }
    deactivateSearch() {
        each(this.searchInputs, (input) => {
            input.closest('.directory__search').classList.remove('active');
        })
    }

    searchHandler (e, searchTerm) {
        if(searchTerm) {
            searchTerm = searchTerm.toLowerCase().trim();
            this.searchTerm = searchTerm;
            this.activateSearch();
        }else{
            this.searchTerm = null;
            this.deactivateSearch();
        }

        each(this.listings.children, (listing) => {
            const searchTerms = [];

            if (listing.dataset.name) {
                searchTerms.push(listing.dataset.name);
            }

            if (listing.dataset.searchTerms) {
                searchTerms.push(listing.dataset.searchTerms);
            }

            if (!searchTerm || searchTerm.length === 0) {
                listing.classList.remove('hidden-by-search');
            } else if (searchTerm.length > 0 && searchTerms.some(value => this.searchTermMatches(value, searchTerm))) {
                listing.classList.remove('hidden-by-search');
            } else {
                listing.classList.add('hidden-by-search');
            }
        });

        this.checkForZeroResults();
        this.recordState();
    }

    /**
     * Searches the specified value to see if the term matches it.
     * @param value The value to search within.
     * @param term The term to search for within the value.
     * @returns {boolean} True, if the term was found within the value.
     */
    searchTermMatches(value, term) {
        value = this.removeSpecialCharacters(value).toLowerCase();
        term = this.removeSpecialCharacters(term).toLowerCase();
        return value.includes(term);
    }

    /**
     * Removes the special characters from the specified string value.
     * @param {string} value The string that may contain special characters
     *      (e.g., "Mandel's-Brats & Relish").
     * @returns The string without special characters (e.g., "MandelsBrats Relish").
     */
    removeSpecialCharacters(value) {
        if (!value || !value.length) {
            return '';
        }
        const normalCharsRegex = new RegExp('[a-z0-9 ]+', 'gi'),
            multipleSpacesRegex = new RegExp(' +', 'g'),
            matches = value.match(normalCharsRegex) || [],
            sanitized = matches.join('');
        return sanitized.replace(multipleSpacesRegex, ' ');
    }

    checkForZeroResults() {
        let visibleCount = this.listings.children.length
        each(this.listings.children, (listing) => {
            if(listing.offsetParent === null) {
                visibleCount--;
            }
        })

        if(!visibleCount) {
            this.listings.classList.add('no-results');
        }else{
            this.listings.classList.remove('no-results');
        }

    }

    parseUrlParams() {
        let params = this.getUrlVars();

        return {
            filter: params['filter'],
            subfilter: params['subfilter'] ? params['subfilter'].split('|') : null,
            term: params['term']
        };
    }

    getInitialState() {
        let state = {};
        const params = this.parseUrlParams();
        let filterOnInit = false;

        if(params.hasOwnProperty('filter') && params.filter) {
            state.filter = params.filter;
            filterOnInit = true;
        }else if(this.el.dataset.main) {
            state.filter = this.el.dataset.main;
        }

        if(params.hasOwnProperty('subfilter') && params.subfilter) {
            state.subfilter = params.subfilter;
            filterOnInit = true;
        }else if(this.el.dataset.sub) {
            state.subfilter = this.el.dataset.sub;
        }

        if(params.hasOwnProperty('term') && params.term) {
            state.term = params.term;
        }else if(this.el.dataset.term) {
            state.term = this.el.dataset.term;
        }

        state.filterOnInit = filterOnInit;

        return state;
    }

    orderColumn(colHeader){
        //this would be 'name' or 'suite'
        const orderVal = colHeader.dataset.listingHeader;

        //determine what order the list should display as
        const order = colHeader.classList.contains('desc') ? 'asc' : 'desc';

        //since we are sorting the list, we need to convert node list into an array. cannot call sort on node list
        const rowsArray = Array.prototype.slice.call(this.listingRows, 0);

        colHeader.classList.remove('desc', 'asc');
        colHeader.classList.add(order);

        //change the previous active order header to default state
        if(this.activeOrderHeader != null && this.activeOrderHeader != colHeader){
            this.activeOrderHeader.classList.remove('desc', 'asc');
        }
        this.activeOrderHeader = colHeader;

        //compare the data value of the order property with each item in the list
        var sortByOrderVal = function(a,b){
            if(order === "desc"){
                return b.dataset[orderVal].toLowerCase().localeCompare(a.dataset[orderVal].toLowerCase());
            } else{
                return a.dataset[orderVal].toLowerCase().localeCompare(b.dataset[orderVal].toLowerCase());
            }
        }
        rowsArray.sort(sortByOrderVal);

        //remove all the listings from the screen
        each(this.listingRows, (row) => {
            row.parentNode.removeChild(row);
        });

        //append the listings. Now they are in the new desired order
        each(rowsArray, (row) => {
            this.listings.appendChild(row);
        });
    }
    /**
     * checks to see that atleast one of the objects values is set
     */
    checkValues (obj) {
        let isEmpty = true;

        for (key in obj) {
            if(obj[key]) {
                isEmpty = false;
            }
        }

        return isEmpty;
    }

    getUrlVars() {
        let vars = {};
        const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
            vars[key] = decodeURIComponent(value);
        });
        return vars;
    }
}